import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

interface IStylesProps {
  columnsNumber: number;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  tableWrapper: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "auto"
  },
  appPageTable: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: "200%",
      width: "200%"
    },
    fontSize: 12
  },
  appPageTableHeader: {
    position: "relative",
    padding: "0 24px",
    display: "grid",
    gridTemplateColumns: ({ columnsNumber }) => `repeat(${columnsNumber}, 1fr)`,
    backgroundColor: "#fff",
    borderBottom: "1px solid #ccc",
    borderTop: "1px solid #ccc",
    top: 0,
    zIndex: 0
  },
  appPageTableContent: {
    overflow: "auto",
    maxHeight: "calc(100dvh - 220px)",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100dvh - 266px)"
    }
  },
  tableHeaderCell: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 45,
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      width: 16
    },
    "&:first-child": {
      justifyContent: "flex-start",
      paddingLeft: "1em"
    }
  },
  tableBodyRow: {
    minHeight: "50px",
    display: "grid",
    gridTemplateColumns: ({ columnsNumber }) => `repeat(${columnsNumber}, 1fr)`,
    padding: "0 24px",
    borderBottom: "1px solid #eeeeee",
    backgroundColor: "#fff",
    "&:nth-child(odd)": {
      backgroundColor: "#fbfbfb"
    },
    "&.clickable": {
      cursor: "pointer"
    }
  },
  tableBodyCell: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    wordBreak: "break-word",
    padding: "12px 0",
    "&:first-child": {
      justifyContent: "flex-start",
      paddingLeft: "1em"
    }
  }
}));
